import { render } from "./addDepartment.vue?vue&type=template&id=22c08d37"
import script from "./addDepartment.vue?vue&type=script&lang=js"
export * from "./addDepartment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__